import AbstractRepository from "@/repositories/AbstractRepository";

export default class CreativeGroupFormFormatDefinitionRepository extends AbstractRepository {
    protected static resource: string = "ptf-monocle-creativegroupformatformdefinition";

    protected static defaultFields: string[] = [
        "uuid",
        "label",
        "suppliers.uuid",
        "suppliers.label",
        "suppliers.endDate",
        "supports.uuid",
        "supports.label",
        "supports.endDate",
        "supports.suppliers.uuid",
        "places.uuid",
        "places.label",
        "places.endDate",
        "places.supports.uuid",
        "formatTypes.uuid",
        "formatTypes.label",
        "formatTypes.endDate",
        "formatTypes.places.uuid",
        "formats.uuid",
        "formats.label",
        "formats.endDate",
        "formats.formatTypes.uuid",
    ];
}
